import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { stringUtils } from 'front-onceforall-core';
import { RFA_RESTART_MESSAGE } from '../../../utils/constant';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RefusalMessageView = props => {
  const isARestart = RFA_RESTART_MESSAGE.MESSAGE === props.reason;
  const message = isARestart ? stringUtils.getStrongs(I18n.t('request.page.rfaRestartMessage', {
    date: I18n.l(props.date, {
      dateFormat: 'datetime.shortDate'
    })
  })) : stringUtils.getStrongs(I18n.t('request.page.refusalMessage', {
    organisation: props.organisation.fullName,
    date: I18n.l(props.date, {
      dateFormat: 'datetime.shortDate'
    })
  }));
  const reason = isARestart ? null : /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("strong", {
      children: props.reason
    })
  });
  return /*#__PURE__*/_jsxs("div", {
    className: "box rejected mb-5",
    children: [/*#__PURE__*/_jsx("div", {
      children: message
    }), reason]
  });
};
RefusalMessageView.propTypes = {
  organisation: PropTypes.object.isRequired,
  date: PropTypes.string.isRequired,
  reason: PropTypes.string.isRequired
};
export default RefusalMessageView;